module.exports = __webpack_public_path__ + "img/scientist10.7fe66c2a.jpg";